import { connect } from 'react-redux';
import ProductDialog from './product-dialog';
import {
  updateProductAction,
  toggleProductDialog,
  loadMenuTreeAction,
  updateMenuAction,
  updateCategoryAction,
  updateMenuEntryAction,
  loadProductsAction,
  updateMenusAction,
  updateCategoriesAction,
  updateMenuEntriesAction,
  updateProductsAction,
} from '../../reducers/menu.reducers';

const mapStateToProps = state => ({
  productDialogOpen: state.menu.productDialogOpen,
  user: state.authentication.user,
  menus: state.menu.menus,
  isLoadingMenus: state.menu.isLoadingMenus,
  isLoadingProducts: state.menu.isLoadingProducts,
  products: state.menu.products,
});

const mapDispatchToProps = dispatch => ({
  toggleProductDialog: productDialogOpen => dispatch(toggleProductDialog(productDialogOpen)),
  loadMenuTree: locationId => dispatch(loadMenuTreeAction.INIT(locationId)),
  loadProducts: locationId => dispatch(loadProductsAction.INIT(locationId)),
  updateMenu: (menuId, data) => dispatch(updateMenuAction.INIT({ menuId, data })),
  updateCategory: (categoryId, data) => dispatch(updateCategoryAction.INIT({ categoryId, data })),
  updateMenuEntry: (menuEntryId, data) => dispatch(updateMenuEntryAction.INIT({ menuEntryId, data })),
  updateProduct: (productId, data) => dispatch(updateProductAction.INIT({ productId, data })),
  updateMenus: (menuIds, data) => dispatch(updateMenusAction.INIT({ menuIds, data })),
  updateCategories: (categoryIds, data) => dispatch(updateCategoriesAction.INIT({ categoryIds, data })),
  updateMenuEntries: (menuEntryIds, data) => dispatch(updateMenuEntriesAction.INIT({ menuEntryIds, data })),
  updateProducts: (productIds, data) => dispatch(updateProductsAction.INIT({ productIds, data })),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductDialog);
